import React, { useState, useCallback } from 'react';

import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { VisibilityOutlined, VisibilityOffOutlined } from '@mui/icons-material';

import { Text, TextProps } from './Text';

export const Password: React.FC<TextProps> = ({ ...props }) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const handleClickShowPassword = useCallback(() => setShowPassword(!showPassword), [showPassword]);

  return (
    <Text
      {...props}
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton aria-label="Toggle password visibility" onClick={handleClickShowPassword} color="inherit">
              {showPassword ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
